import { CommonLayout } from '@atlassian/company-hub-common';

import { i18n } from './messages';

export const SPOTLIGHT_EXTENSION_KEY = 'spotlight';

export const layoutOptions = [
	{
		label: i18n.splitDesignContentFirstLabel,
		description: i18n.splitDesignContentFirstDescription,
		value: CommonLayout.SPLIT_IMAGE_RIGHT,
	},
	{
		label: i18n.splitDesignImageFirstLabel,
		description: i18n.splitDesignImageFirstDescription,
		value: CommonLayout.SPLIT_IMAGE_LEFT,
	},
	{
		label: i18n.solidColorBackgroundLabel,
		description: i18n.solidColorBackgroundDescription,
		value: CommonLayout.NO_IMAGE_BACKGROUND,
	},
	{
		label: i18n.frameAboveImageLabel,
		description: i18n.frameAboveImageDescription,
		value: CommonLayout.FRAME_ABOVE_IMAGE,
	},
];
